import type { PublicNimbusOptions } from '@nimbus/types'
import { useRuntimeConfig } from '#imports'

export const useNimbusConfig = (): PublicNimbusOptions => {
    const config = useRuntimeConfig()

    return config.public.nimbus
}
